module.exports = __webpack_public_path__ + "img/nt50-00-80-1_2.prt.3ebee8de.jpg";